// React
import { FC } from 'react'

// Libraries
import { useTranslation } from 'react-i18next'

// Custom
import { NavBarContainer, NavBarOptions } from './styled'

type Option = {
  label: string
  path: string
}

type Props = {
  navOptions?: Option[]
  footer?: boolean
}

const NavMenu: FC<Props> = ({ navOptions, footer }: Props) => {
  const { t } = useTranslation()

  return (
    <NavBarContainer data-testid="navMenu" footer={footer}>
      {navOptions?.map((option, key) => {
        return (
          <NavBarOptions
            key={key.toString()}
            to={option.path}
            activeClassName="active"
            footer={footer}>
            {t(option.label)}
          </NavBarOptions>
        )
      })}
    </NavBarContainer>
  )
}

export default NavMenu
